export default {"src":"/_next/static/media/checkPrimaryFilled.7bee4394.svg","height":24,"width":24};